export const isAWSStage = (stage?: string) =>
  ['dev', 'stage', 'prod'].includes(stage ?? '');
